import HeroSection from "@/components/layout/HeroSection";
import GallerySection from "@/components/features/artwork/GallerySection";
import ApprovedProofSection from "@/components/features/proof/ApprovedProofSection";
import { getApprovedProofItemsForHomepage } from "@/constants/approvedProof";
import ProcessSection from "@/components/layout/ProcessSection";
import PricingSection from "@/components/layout/PricingSection";
import SeoInternalLinksSection from "@/components/layout/SeoInternalLinksSection";
import FAQSection from "@/components/layout/FAQSection";
import BlogPreviewSection from "@/components/layout/BlogPreviewSection";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import { absoluteUrl } from "@/constants/site";
import { homeStructuredDataSchema } from "@/constants/homeFaq";

const Index = () => {
  const homepageProofItems = getApprovedProofItemsForHomepage();

  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEOHead
        title="Ma Photo en Tableau — Photo IA imprimée en tableau personnalisé"
        description="Transformez une photo de famille, de couple ou d'animal en tableau personnalisé grâce à l'IA. 16+ styles artistiques, impression premium, livraison France et Europe. À partir de 29,99 €."
        canonical={absoluteUrl()}
        schema={homeStructuredDataSchema}
      />
      <HeroSection />
      <GallerySection />
      <ApprovedProofSection items={homepageProofItems} />
      <ProcessSection />
      <PricingSection />
      <SeoInternalLinksSection />
      <FAQSection />
      <BlogPreviewSection />
      <Footer />
    </div>
  );
};

export default Index;
